//@ts-nocheck
import { IResource } from "@/hooks";
import { GridRowId } from "@mui/x-data-grid";
import { useState } from "react";
import { AdminTemplate, MessageListingTable, MessageAddModal } from "../../components"

export const SettingsMessage = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messageData, setMessageData] = useState<IResource>();

  const handleAddButton = () => setIsOpen(true);

  const handleLanguageClick = (row: IResource, lang: "tr" | "en") => {
    setIsOpen(true);
    if (lang === "en") {
      setMessageData({
        ...row,
        id: row.id2,
        value: row.value2,
        language: row.language2,
      });
    } else {
      setMessageData(row);
    }
  };

  return (
    <AdminTemplate
      headerProps={{
        headerTitle: "Mesaj Yönetimi",
        onClickAddButton: handleAddButton,
      }}
    >
      <MessageListingTable
        isModalOpen={isOpen}
        onLanguageClick={handleLanguageClick}
      />
      {isOpen && (
        <MessageAddModal
          message={messageData}
          isOpen={isOpen}
          onClose={() => {
            setIsOpen(false);
            setMessageData(undefined);
          }}
          title={messageData ? "Mesaj Güncelle" : "Mesaj Ekle"}
        />
      )}
    </AdminTemplate>
  );
}
